import { render } from "./Crumbs.vue?vue&type=template&id=5f637f9c&scoped=true"
import script from "./Crumbs.vue?vue&type=script&lang=js"
export * from "./Crumbs.vue?vue&type=script&lang=js"

import "./Crumbs.vue?vue&type=style&index=0&id=5f637f9c&lang=scss&scoped=true"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f637f9c"]])

export default __exports__